// src/components/common/CmsPage.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCmsPage } from "../../features/user/cmsThunks";

// Function to decode escaped HTML entities
function decodeHtml(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export default function CmsPage({ pageKey, title }) {
  const dispatch = useDispatch();
  const { page, loading, error } = useSelector((s) => s.cms);

  useEffect(() => {
    dispatch(fetchCmsPage(pageKey));
  }, [dispatch, pageKey]);

  const decodedContent = page?.content ? decodeHtml(page.content) : "";

  return (
    <div className="cms-wrapper">
      <div className="cms-header">
        <h1>{title}</h1>
        <div className="cms-divider"></div>
      </div>

      {loading && <p className="cms-loading">Loading content...</p>}
      {error && <p className="cms-error">{error}</p>}

      {decodedContent ? (
        <div
          className="cms-content text-center"
          dangerouslySetInnerHTML={{ __html: decodedContent }}
        />
      ) : (
        !loading && <p className="cms-no-content">No content available.</p>
      )}

      <style>{`
        .cms-wrapper {
          max-width: 900px;
          margin: 40px auto;
          background: #ffffff;
          padding: 40px 50px;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          animation: fadeIn 0.3s ease-in-out;
        }

        .cms-header h1 {
          text-align: center;
          font-size: 38px;
          font-weight: 800;
          color: #222;
        }

        .cms-divider {
          width: 80px;
          height: 4px;
          background: #6c63ff;
          margin: 12px auto 30px auto;
          border-radius: 20px;
        }

        .cms-content {
          font-size: 18px;
          line-height: 1.8;
          color: #444;
        }

        .cms-content h2, .cms-content h3 {
          margin-top: 25px;
          font-weight: 700;
          color: #222;
        }

        .cms-loading {
          text-align: center;
          font-size: 18px;
          color: #777;
        }

        .cms-error {
          text-align: center;
          color: #e63946;
          font-size: 18px;
          margin-top: 10px;
          font-weight: 600;
        }

        .cms-no-content {
          text-align: center;
          font-size: 17px;
          color: #777;
          margin-top: 20px;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
